<template>
  <button ref="el" v-click-away="close" class="tooltip-button" @click="onClick">
    <slot />
    <div
      v-if="visible"
      class="tooltip max-w-[400px]"
      :class="['is-' + position, 'is-' + type]"
    >
      <slot name="content" />
    </div>
  </button>
</template>

<script lang="ts" setup>
const el = ref<HTMLDivElement>()

withDefaults(
  defineProps<{
    type?: string
  }>(),
  {
    type: 'default',
  },
)

const visible = ref(false)
const position = ref('center')

function close() {
  visible.value = false
}

function onClick() {
  if (visible.value) {
    close()
    return
  }

  const overflowParent = document.body
  if (overflowParent && el.value) {
    const pRect = overflowParent.getBoundingClientRect()
    const tRect = el.value.getBoundingClientRect()
    const center = pRect.x + pRect.width / 2
    if (Math.abs(center - tRect.x) < 200) {
      position.value = 'center'
    } else if (tRect.x > center) {
      position.value = 'right'
    } else {
      position.value = 'left'
    }
  }
  visible.value = true
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.tooltip-button.button {
  @apply relative;
}
.tooltip {
  @apply absolute z-100 mb-[1rem] bg-background p-[1rem] text-left text-[1rem] whitespace-normal text-scheme-invert;
  &.is-success {
    @apply bg-success text-white;
  }
  @variant tablet {
    z-index: 10000;
    width: calc(100vw - 2rem);
    left: 1rem;
    top: 100%;
    &.is-left {
      left: -0.5rem;
    }
    &.is-right {
      right: -0.5rem;
    }
    &.is-center {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
